module.exports = __webpack_public_path__ + "img/VIB.0a7096e9.png";